<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :key="pageKey"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :createModeIsEditMode="true"
        :primaryLabel="model.CustomerName"
        :secondaryLabel="model.CustomerCode"
        recordType="Customer"
        v-if="model.CustomerCode"
      />
    </template>
    <div class="css-v2 split-view customer-note">
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <div class="css-v2 split-view-list">
            <gc-filter-split-view
              :showLeftContainer="showFilterLeftContainer"
              :showRightContainer="showFilterRightContainer"
            >
              <template #leftContent>
                <dx-data-grid
                  :data-source="dataSourceConfig"
                  ref="noteGrid"
                  :columns="columns"
                  :height="gridHeight - 20"
                  @selection-changed="onSelectionChanged"
                  @toolbar-preparing="onToolbarPreparing($event)"
                  @content-ready="addGridNoResults($event)"
                  :selection="{ mode: 'single' }"
                  v-if="model.CustomerCode"
                  @exporting="
                    onGridToExcelExporting(
                      $event,
                      `Customer - ${baseView.id} - Notes`,
                      columns
                    )
                  "
                >
                  <DxPaging :page-size="50" :enabled="false" />
                  <DxPager :visible="false" />

                  <DxScrolling
                    :mode="'virtual'"
                    :row-rendering-mode="'virtual'"
                    :preloadEnabled="true"
                  />
                  <DxExport :enabled="true" />
                  <template #note-date-cell-template="{ data }">
                    <span>
                      {{
                        data.displayValue.dateWithOffset().toShortDateString() +
                          ", " +
                          data.displayValue.dateWithOffset().toShortTimeString()
                      }}</span
                    >
                  </template>

                  <template #customer-contact-cell-template="{ data }">
                    <GcDescriptionCodeCellTemplate
                      :description="data.data.CustomerContactFullName"
                      :code="data.data.CustomerContactCode"
                    />
                  </template>
                </dx-data-grid>
              </template>
              <template #rightContent>
                <gc-advance-filter-panel
                  :toolbar="filterToolbar"
                  :setFilterFormHeight="filterFormHeight"
                  :sideBarTabs="sideBarTabs"
                  :filterFormItems="filterFormItems"
                  :filterModel="getAdvanceFilterModel"
                  :isJson="false"
                  :screenType="'supplier-contact-list'"
                  :data-source-config="dataSourceConfig"
                  :initial-filter="initialFilter"
                  v-if="model.CustomerCode"
                >
                </gc-advance-filter-panel>
              </template>
            </gc-filter-split-view>
          </div>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem
              :options="toolbar.audit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.delete"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              :visible="formsConfig.editableOption"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
              :visible="formsConfig.editableOption"
            />

            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />

            <DxItem
              :options="toolbar.close"
              location="after"
              widget="dxButton"
            />
          </DxToolbar>
          <div class="view-card responsive-paddings">
            <form v-if="loadingCompleted">
              <DxForm
                :form-data.sync="model"
                :read-only="false"
                :show-colon-after-label="false"
                :show-required-mark="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :col-count-by-screen="formsConfig.splitViewColCountByScreen"
                label-location="left"
                :customizeItem="customizeItem"
                :items="items"
                @content-ready="onFormContentReady"
              >
                <template #contact="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary"
                      >{{ data.FirstName }} {{ data.Surname }}</span
                    >
                  </div>
                </template>
              </DxForm>
            </form>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerContactService } from "../../_services/api/customers/customer-contact.service";
import { CustomerNoteService } from "../../_services/api/customers/customer-note.service";

import BaseViewMixin from "../../v1/_mixins/base.view";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import validationEngine from "devextreme/ui/validation_engine";
import { FeatureStorage } from "../../_services/storage";

export default {
  mixins: [BaseViewMixin, CustomerTabsMixin],
  created() {
    this.selectedIndex = 3;
  },
  updated() {
    if (this.loadingCompleted)
      validationEngine.validateGroup(this.formsConfig.validationGroup);
  },
  components: {},
  data() {
    return {
      toolbar: {
        close: {
          icon: "close",
          tabIndex: -1,
          onClick: this.close,
        },
        edit: {
          icon: "edit",
          tabIndex: -1,

          onClick: () => {
            this.$router.push({
              path: `/customer-note/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          tabIndex: -1,
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickSave();
            this.saveCustomerNote(e);
          },
        },
        delete: {
          icon: "trash",
          tabIndex: -1,
          validationGroup: "formsData",
          onClick: (e) => {
            this.$logger.trackEventButtonClickDelete();
            this.deleteCustomerNote(e);
          },
        },
        audit: {
          icon: "clock",
          tabIndex: -1,
          onClick: () => {
            this.displayAuditPopup(
              this.model.CreatedBy,
              this.model.DateCreated,
              this.model.ChangedBy,
              this.model.DateChanged
            );
          },
        },
      },
      advanceFilterModel: {
        CustomerContactCode: "",
        NoteDate: null,
      },
      model: {
        Note: "",
        CustomerContactCode: null,
        CustomerContactLineNo: null,
        CustomerCode: "",
        CustomerName: "",
        NoteDate: new Date(),
        DateChanged: "",
        DateCreated: "",
        ChangedBy: "",
        CreatedBy: "",
        RecordId: "00000000-0000-0000-0000-000000000000",
        LineNo: 0,
      },
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Notes",
          message: "Get Started, Add a Note",
        },
      },
    };
  },
  computed: {
    initialFilter() {
      return [["CustomerCode", "=", this.model.CustomerCode]];
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "NoteDate",
              gcType: "Date",
              editorType: "DxDateBox",
              gcLabel: "Date",
            },

            {
              dataField: "CustomerContactCode",
              gcLabel: "Contact",
              gcType: "String",
              editorType: "dxTagBox",
              editorOptions: {
                dataSource: CustomerContactService.dataSourceConfigList(
                  "api/CustomerContactList",
                  {
                    select: [
                      "LineNo",
                      "RecordId",
                      "FirstName",
                      "Surname",
                      "RecordIdAsString",
                    ],
                    filter: [
                      ["Inactive", "=", "N"],
                      "and",
                      ["CustomerCode", "=", this.model.CustomerCode],
                    ],
                  }
                ),
                valueExpr: "RecordIdAsString",
                searchExpr: ["FirstName", "Surname"],
                searchMode: "contains",
                itemTemplate: "rep-item-template",
                searchEnabled: true,
                displayExpr: function(data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
              },
            },
          ]),
        },
      ];
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Date",
          dataField: "NoteDate",
          gcType: "Datetime",
          gcSubType: "PrimaryDate",
          sortOrder: "desc",
          dataType: "datetime",
          customizeText: function(cellInfo) {
            return cellInfo.valueText;
          },
          cellTemplate: "note-date-cell-template",
        },
        {
          gcLabel: "Contact",
          dataField: "CustomerContactFullName",
          gcType: "String",
          minWidth: 220,
        },
        {
          gcLabel: "Note",
          dataField: "Note",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
        },
        {
          gcLabel: "Changed By",
          dataField: "ChangedBy",
          gcType: "String",
          minWidth: 220,
        },
      ]);
    },
    items() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "NoteDate",
              gcType: "Datetime",
              gcLabel: "Date / Time",
            },
            {
              dataField: "CustomerContactLineNo",
              gcLabel: "Contact",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: CustomerContactService.dataSourceConfig(
                  "api/CustomerContact",
                  {
                    select: ["LineNo", "RecordId", "FirstName", "Surname"],
                    filter: [
                      ["Inactive", "=", "N"],
                      "and",
                      ["CustomerCode", "=", this.model.CustomerCode],
                    ],
                  }
                ),
                valueExpr: "LineNo",
                searchExpr: ["FirstName", "Surname"],
                searchMode: "contains",
                showClearButton: true,
                itemTemplate: "contact",
                searchEnabled: true,
                onItemClick: this.onContactItemClicked,
                displayExpr: function(data) {
                  if (data) return data.FirstName + " " + data.Surname;
                },
              },
            },
            {
              dataField: "Note",
              gcLabel: "Note",
              gcType: "String",
              editorType: "dxTextArea",
              cssClass: "note-text-area",
              editorOptions: {
                maxLength: 1000,
                height: 200,
              },
              required: true,
            },
          ]),
        },
      ];

      return formFields;
    },
    dataSourceConfig() {
      return CustomerNoteService.dataSourceConfig("api/CustomerNoteList", {
        select: [
          "Note,LineNo,CustomerCode,RecordId,NoteDate,CustomerContactCode,CustomerContactFullName,NoteDateString",
        ],
        keyType: {
          NoteDate: "String",
        },
        // sort: [{ selector: "NoteDate", desc: true }],
        filter: [["CustomerCode", "=", this.model.CustomerCode]],
        // postProcess: (data) => {
        //   data.forEach(element => {
        //     element.NoteDate = element.NoteDate.dateWithOffset();
        //   });

        //   console.log("data ", data);
        //   return data;
        // },
        // map: (mapD) => {
        //   mapD.NoteDate = this.displayDateTimeValue(mapD.NoteDate);

        //   console.log("mapD ", mapD.NoteDate);
        //   // console.log("mapD ", d);
        //   return mapD;
        // }
      });
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      if (
        (this.baseView.mode == "review" || this.baseView.mode == "edit") &&
        this.baseView.id.length < 36
      ) {
        return false;
      }

      return !(this.baseView.mode == "review" && this.baseView.id == "");
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
    showRightContainer() {
      setTimeout(() => {
        let grid = this.$refs["noteGrid"].instance;
        grid.updateDimensions();
      }, 10);
    },
  },
  methods: {
    onFormContentReady(e) {
      if (e) {
        validationEngine.validateGroup(this.formsConfig.validationGroup);
        setTimeout(() => {
          e.component
            .instance()
            .getEditor("NoteDate")
            .focus();
        }, 100);
      }
    },
    onContactItemClicked(e) {
      this.model.CustomerContactCode = e.itemData.RecordId;
    },
    async close() {
      if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          let grid = this.$refs["noteGrid"].instance;
          grid.clearSelection();

          this.baseView.id = this.model.CustomerCode;
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-note/${this.baseView.id}`,
          });
        } else {
          this.next(false);
        }
      } else {
        let grid = this.$refs["noteGrid"].instance;
        grid.clearSelection();

        this.baseView.id = this.model.CustomerCode;
        this.setIgnoreRouteChangeConfirmation();
        this.$router.push({
          path: `/customer-note/${this.baseView.id}`,
        });
      }
    },
    backButtonFunction() {
      this.$logger.debug(`Form dirty:  ${this.dirty}`);
      if (this.isDirty == false) {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/customer",
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "exportButton" &&
          item.name !== "searchPanel" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";
      exportButton.location = "after";
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            visible: FeatureStorage.checkPermission("CustomerNote", "create"),
            onClick: async () => {
              this.$logger.trackEventButtonClickAddNew();

              if (this.baseView.mode == "edit") {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to leave?",
                  "Unsaved changes"
                );

                if (confirmLeaving) {
                  this.setIgnoreRouteChangeConfirmation();
                  this.createNewNote();
                }
              } else {
                this.createNewNote();
              }
            },
          },
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");
            },
          },
        }
        // exportButton
      );
    },
    createNewNote() {
      this.model.Note = "";
      this.model.CustomerContactCode = null;
      this.model.CustomerContactLineNo = null;
      (this.model.NoteDate = new Date()),
        (this.model.RecordId = "00000000-0000-0000-0000-000000000000");
      this.model.DateChanged = "";
      this.model.DateCreated = "";
      this.model.ChangedBy = "";
      this.model.CreatedBy = "";
      this.model.LineNo = 0;

      this.baseView.id = this.model.CustomerCode;

      this.$router.push({
        path: `/customer-note/create/${this.baseView.id}`,
      });
    },
    handleLocalRouteChange() {
      let that = this;
      this.showLoading(true);
      if (
        (this.baseView.mode === "review" || this.baseView.mode === "edit") &&
        this.baseView.id.length == 36
      ) {
        this.model.RecordId = this.baseView.id;
        this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            that.model.Note = response.data.value[0].Note;
            that.model.CustomerContactLineNo = null;
            that.model.CustomerContactCode =
              response.data.value[0].CustomerContactCode;
            that.model.CustomerCode = response.data.value[0].CustomerCode;
            that.model.CustomerName = response.data.value[0].Customer.Name;

            that.model.NoteDate =
              response.data.value[0].NoteDate == "" ||
              response.data.value[0].NoteDate == null
                ? null
                : new Date(response.data.value[0].NoteDate);

            that.model.RecordId = response.data.value[0].RecordId;
            that.model.DateChanged = response.data.value[0].DateChanged;
            that.model.DateCreated = response.data.value[0].DateCreated;
            that.model.ChangedBy = response.data.value[0].ChangedBy;
            that.model.CreatedBy = response.data.value[0].CreatedBy;
            that.model.LineNo = response.data.value[0].LineNo;

            if (that.model.CustomerContactCode != null) {
              CustomerContactService.getByRecordId(
                that.model.CustomerContactCode
              ).then((response3) => {
                if (response3.data.value.length > 0) {
                  that.model.CustomerContactLineNo =
                    response3.data.value[0].LineNo;
                }
              });
            }

            that.showLoading(false);
          }
          // that.refreshView();
          that.loadingCompleted = true;
        });
      } else {
        if (!this.model.CustomerCode) {
          CustomerService.getByCode(that.baseView.id).then((response2) => {
            //     // eslint-disable-next-line no-debugger
            // debugger;
            if (response2.data.value.length > 0) {
              that.model.CustomerCode = response2.data.value[0].Code;
              that.model.CustomerName = response2.data.value[0].Name;
              // that.refreshView();
            }
            that.loadingCompleted = true;
          });
        } else {
          if (this.showRightContainer) this.loadingCompleted = true;
        }
        that.showLoading(false);
      }
    },
    contactExistsRuleCallback(params) {
      return new Promise((resolve) => {
        if (this.model.CustomerContactCode == "") {
          resolve(true);
        } else {
          CustomerContactService.getByCustomerCodeLineNo(
            this.model.CustomerCode,
            params.value
          ).then((response) => {
            if (
              response.data.value.length > 0 &&
              response.data.value[0].Inactive == "N"
            ) {
              this.model.CustomerContactCode = response.data.value[0].RecordId;
              resolve(true);
            } else {
              this.model.CustomerContactCode = null;
              resolve(false);
            }
          });
        }
      });
    },
    async getRecord() {
      return CustomerNoteService.getByRecordId(this.baseView.id);
    },
    onSelectionChanged({ selectedRowsData }) {
      if (selectedRowsData.length == 0) {
        return;
      }

      this.baseView.id = selectedRowsData[0].RecordId;
      this.$router.push({
        path: `/customer-note/review/${selectedRowsData[0].RecordId}`,
      });
      this.baseView.tempId = this.model.CustomerCode;
    },

    async deleteCustomerNote() {
      let that = this;

      let confirmLeaving = await this.$confirm(
        `Are you sure you want to delete ${this.model.Note}?`,
        "Delete Note"
      );

      if (confirmLeaving) {
        this.showLoading(true);
        await CustomerNoteService.delete({
          RecordId: this.model.RecordId,
        })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            that.showLoading(false);
            that.close();
            let grid = this.$refs["noteGrid"].instance;
            grid.refresh();
          })
          .catch((error) => {
            this.displayServerError(error, "Customer Note delete failed");
          });
      }
    },
    async saveCustomerNote(e) {
      const result = await e.validationGroup.validate();
      if (!result.isValid) {
        this.addErrorMessagesFromValidationResult(result);
        this.displayValidationSummary();
        return;
      }
      this.showLoading(true);

      let payload = {
        Note: this.model.Note,
        CustomerContactCode:
          this.model.CustomerContactCode == ""
            ? null
            : this.model.CustomerContactCode,
        CustomerCode: this.model.CustomerCode,
        NoteDate: JSON.parse(
          JSON.stringify(this.model.NoteDate, this.replacer)
        ),
        RecordId: this.model.RecordId,
        LineNo: this.model.LineNo,
      };

      await CustomerNoteService.save(this.baseView.mode, payload)
        .then((res) => {
          if (this.baseView.mode == "create") {
            this.model.RecordId = res.data.RecordId;
            this.model.LineNo = res.data.LineNo;
          }

          this.showLoading(false);
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveCustomerNote", res);
          this.$notify(
            `Customer Note ${this.model.Note} saved successfully`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-note/review/${this.model.RecordId}`,
          });
          this.baseView.tempId = this.model.CustomerCode;
        })
        .catch((error) => {
          this.displayServerError(error, "Customer Note save failed");
        });
    },
  },
};
</script>

<style lang="scss">
.customer-note {
  .note-text-area {
    .dx-textbox {
      .dx-invalid-message {
        transform: translate(0px, -15px) !important;
      }
    }
  }
}
</style>
